module.exports = __webpack_public_path__ + "static/media/childgrowth-bg.81e2bd09.png";